import { render, staticRenderFns } from "./printCertificate.vue?vue&type=template&id=0fe1ada5&"
import script from "./printCertificate.vue?vue&type=script&lang=js&"
export * from "./printCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports